import DocumentAPI from '@/app/apis/main/document/document-api';

export default {
	/**
	 * Retrieves document details for a given pet and document ID.
	 * @async
	 * @param {string} petId - The ID of the pet associated with the document.
	 * @param {string} documentId - The ID of the document to retrieve details for.
	 * @returns {Promise<object>} A Promise that resolves to an object representing the document details.
	 */
	async getDocumentById(petId, documentId) {
		return DocumentAPI.getDocumentById(petId, documentId);
	},

	/**
	 * @return {*} document list
	 */
	async getDocumentLists(documentDetails) {
        return DocumentAPI.getDocumentLists(documentDetails);
	},

	/**
	 * @param {*} docDetails
	 */
	async postDocument(docDetails) {
		return DocumentAPI.postDocument(docDetails);
	},

	/**
	 * @param {*} docInfo
	 * @param {*} docId
	 */
	async updateDocument(docInfo, docId) {
		return DocumentAPI.putDocument(docInfo, docId);
	},
	
	/**
	 * @param {*} petInfo
	 * @param {*} docId
	 */
	async deleteDocument(petInfo, docId) {
		return DocumentAPI.deleteDocument(petInfo, docId);
	}
}